module.exports = __webpack_public_path__ + "img/butterfly.be5030ca.webp";